import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { DetailsComponent } from './details.component';
import { DetailsV2Component } from './detailsv2.component';
import { OldVersionService } from './services/old-version.service';
import { NewVersionService } from './services/new-version.service';
//import { OldVersionMatcher } from './services/old-version.matcher';
//import { NewVersionMatcher } from './services/new-version.matcher';

const appRoutes: Routes = [
  //{
  //  path: '',
  //  component: DetailsComponent
  //},

  {
    path: 'lists/:continent/:listType/2019',
    //matcher: OldVersionMatcher,
    component: DetailsComponent,
    //canActivate: [OldVersionService]  //(year < 2021)
  },
  {
    path: 'lists/:continent/:listType/2020',
    //matcher: OldVersionMatcher,
    component: DetailsComponent,
    //canActivate: [OldVersionService]  //(year < 2021)
  },
  {
    path: 'lists/:continent/:listType/:year',
    //matcher: NewVersionMatcher,
    component: DetailsV2Component,
    //canActivate: [NewVersionService]  //(year >= 2021)
  },
  {
    path: 'lists/:continent/:listType/2019/:previewGuid',
    component: DetailsComponent
  },
  {
    path: 'lists/:continent/:listType/2020/:previewGuid',
    component: DetailsComponent
  },
  {
    path: 'lists/:continent/:listType/:year/:previewGuid',
    component: DetailsV2Component
  },

  /*
  {
    path: 'lists/:continent/:listType/2021',
    //matcher: NewVersionMatcher,
    component: DetailsV2Component,
    //canActivate: [NewVersionService]  //(year >= 2021)
  },
  {
    path: 'lists/:continent/:listType/2022',
    //matcher: NewVersionMatcher,
    component: DetailsV2Component,
    //canActivate: [NewVersionService]  //(year >= 2021)
  },
  {
    path: 'lists/:continent/:listType/:year',
    //matcher: OldVersionMatcher,
    component: DetailsComponent,
    //canActivate: [OldVersionService]  //(year < 2021)
  },
  {
    path: 'lists/:continent/:listType/2021/:previewGuid',
    component: DetailsV2Component
  },
  {
    path: 'lists/:continent/:listType/2022/:previewGuid',
    component: DetailsV2Component
  },
  {
    path: 'lists/:continent/:listType/:year/:previewGuid',
    component: DetailsComponent
  }
  */

];

//export const routing = RouterModule.forRoot(routes);

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    OldVersionService,
    NewVersionService,
  ]
})
export class AppRoutingModule { }
